import React, { useState } from "react";
import styles from "./transaction.module.scss";
import InfoTopBar from "../common/InfoTopBar/InfoTopBar";
import TransactionModal from "./transactionDetails/Transection";

const Transaction = () => {
  const [isOpenTransaction, setIsOpenTransaction] = useState(false);

  const toggleTransaction = () => {
    setIsOpenTransaction(!isOpenTransaction);
  };
  return (
    <div className={styles.container}>
      <div style={{ padding: "10px 25px" }}>
        <InfoTopBar
          heading="Transaction History"
          info="Below is complete transaction history of your account."
          divider={true}
        >
          <div className={styles.rightInfoBar}>
            <label>Type:</label>
            <div className={styles.selectWrapper}>
              <select>
                <option value="1">ALL</option>
                <option value="2">No JS</option>
                <option value="3">Nice!</option>
              </select>
            </div>
            <label>Assets:</label>
            <div className={styles.selectWrapper}>
              <select>
                <option value="1">ALL</option>
                <option value="2">No JS</option>
                <option value="3">Nice!</option>
              </select>
            </div>
          </div>
        </InfoTopBar>
      </div>
      <div style={{position:"relative",padding:"10px"}}>
        <div className={styles.cardWrapper}>
          <div className={styles.cardLabel}>
            <div className={styles.container}>Date & Time</div>
            <div className={styles.container}>Transaction Type</div>
            <div className={styles.container}>Amount</div>
            <div className={styles.container}>{"USD Amount"}</div>
          </div>
          {Array.from(Array(30), (e, i) => {
            return (
              <div className={styles.card} onClick={toggleTransaction}>
                <div className={styles.container}>April 29,2021,5:42:4 AM</div>
                <div className={styles.container}>Send BTC</div>
                <div className={styles.container}>0.024 BTC</div>
                <div className={styles.container}>
                  {"$ 50.00 USD"} <img src={"/assets/Icon-square.svg"} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <TransactionModal isOpen={isOpenTransaction} toggle={toggleTransaction}/>
    </div>
  );
};

export default Transaction;
